<template>
  <!-- 学生画像 -->
  <div class="student-pre">
    <div class="student-header">
      <div
        class="after-btn"
        @click="goStdtentAfter"
      />
    </div>
    <div class="student-main">
      <!-- 左侧 -->
      <div class="student-main-con">
        <div class="student-main-con-item know-yourself">
          <div class="content-item-info">
            <!-- <div class="content-item-info-img">
              图片
            </div> -->
            <img
              class="content-item-info-img"
              src="@/assets/studentImages/know-yourself1.png"
              alt=""
            >
            <div class="text">
              人格稳定：
              <span class="slef-red">优秀</span>
            </div>
          </div>
          <div class="content-item-info">
            <img
              class="content-item-info-img"
              src="@/assets/studentImages/know-yourself2.png"
              alt=""
            >
            <div class="text">
              自我管理：
              <span class="slef-orange">良好</span>
            </div>
          </div>
          <div class="content-item-info">
            <img
              class="content-item-info-img"
              src="@/assets/studentImages/know-yourself3.png"
              alt=""
            >
            <div class="text">
              积极品质：
              <span class="slef-green">及格</span>
            </div>
          </div>
        </div>
        <div class="student-main-con-item interpersonal-relation">
          <div
            v-for="(item, index) in studentPicPreData.personRelationship"
            :key="item.title"
            class="content-item-info barside"
          >
            <div class="content-item-info-bar">
              <div class="content-item-info-title">
                <div class="title-block" />
                {{ item.title }}
              </div>
              <div class="bar-big">
                <div
                  class="bar-small"
                  :style="{backgroundColor: item.color}"
                />
              </div>
            </div>
            <div
              :id="'pieChart'+index"
              class="content-item-info-chart"
            >
              <!-- 环形图 -->
              <div class="div3">
                <div class="circle">
                  <div class="pie-left">
                    <div
                      v-if="Math.ceil(item.perc) * 3.6<180"
                      class="left"
                    />
                    <div
                      v-else
                      class="left"
                      :style="{transform: `rotate(${(Math.ceil(item.perc) * 3.6 - 180)}deg)`}"
                    />
                  </div>
                  <div class="pie-right">
                    <div
                      v-if="Math.ceil(item.perc) * 3.6<180"
                      class="right"
                      :style="{transform: `rotate(${(Math.ceil(item.perc) * 3.6)}deg)`}"
                    />
                    <div
                      v-else
                      class="right"
                      style="transform:rotate(180deg)"
                    />
                  </div>
                  <div class="mask">
                    <span />
                  </div>
                  <div class="num">
                    {{ item.perc }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="student-main-con-item emotional-development">
          <div class="content-item-info">
            <!-- <div class="content-item-info-img">
                图片
              </div> -->
            <img
              class="content-item-info-img"
              src="@/assets/studentImages/emotional-development1.png"
              alt=""
            >
            <div class="content-item-info-count orange">
              32
            </div>
            <div class="text">
              情绪调节
            </div>
          </div>
          <div class="content-item-info">
            <!-- <div class="content-item-info-img">
                图片
              </div> -->
            <img
              class="content-item-info-img"
              src="@/assets/studentImages/emotional-development2.png"
              alt=""
            >
            <div class="content-item-info-count blue">
              87
            </div>
            <div class="text">
              情绪察觉
            </div>
          </div>
          <div class="content-item-info">
            <!-- <div class="content-item-info-img">
                图片
              </div> -->
            <img
              class="content-item-info-img"
              src="@/assets/studentImages/emotional-development3.png"
              alt=""
            >
            <div class="content-item-info-count blue">
              65
            </div>
            <div class="text">
              情绪培养
            </div>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="student-main-center">
        <!-- <div class="audio-status">
          <div
            ref="animation1"
            class="animation2 big-animation"
          />
          <div class="animation3">
            <span class="music-time">焦虑</span>
          </div>
        </div> -->
        <!-- 心理画像 -->
        <ModelSide :preintervention="true" />
        <div class="student-foot">
          <div class="student-foot-title">
            <div class="student-foot-title-big">
              近两周心理健康状态
            </div>
            <div class="status-list">
              <div class="status-list-item">
                学习焦虑
              </div>
              <div class="status-list-item">
                孤独倾向
              </div>
              <div class="status-list-item">
                自责倾向
              </div>
            </div>
          </div>
          <!-- 情绪状态折线图 -->
          <div class="student-foot-con">
            <div class="line-echarts">
              <div
                id="warnBarMainPre"
                style="width:100%;height:100%"
              />
            </div>
            <div class="student-foot-con-vedio">
              <video
                id="showVideo"
                ref="oldVideo"
                preload="auto"
                muted
                src="https://bj.download.cycore.cn/CSB-decompression-planet-service/fe99d4d3-239d-49b9-9aed-e5dcf8acaa6f/【视频】.考试焦虑的表现和成因-初高中版.mp4"
                webkit-playsinline="true"
                playsinline="true"
                x5-video-player-type="h5"
                x-webkit-airplay="true"
                controls
              />
              应对考试焦虑的策略
            </div>
            <!-- <div class="student-foot-con-vedio">
              缓解考试焦虑自助联系
            </div> -->
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="student-main-con">
        <div class="student-main-con-item learn-study">
          <!-- <div class="item-title">
            学会学习
          </div> -->
          <div
            id="radarEcharts"
            class="item-container"
            style="width:100%;height:100%"
          />
        </div>
        <div class="student-main-con-item social-adaptability">
          <!-- <div class="item-title">
            社会与适应
          </div> -->
          <div class="student-main-con-social">
            <div class="item-container">
              <div
                id="echartsLiquidfillStressPre"
                class="item-echarts"
              />
              <!-- <img
                src="@/assets/studentImages/social-adaptability1.png"
                alt=""
              > -->
              <div class="text">
                压力
              </div>
            </div>
            <div class="item-container">
              <!-- <img
                src="@/assets/studentImages/social-adaptability2.png"
                alt=""
              > -->
              <div
                id="echartsLiquidfillSuitPre"
                class="item-echarts"
              />
              <div class="text">
                适应
              </div>
            </div>
            <div class="item-container">
              <div
                id="echartsLiquidfillMethodPre"
                class="item-echarts"
              />
              <!-- <img
                src="@/assets/studentImages/social-adaptability3.png"
                alt=""
              > -->
              <div class="text">
                应对方式
              </div>
            </div>
          </div>
        </div>
        <div class="student-main-con-item careers-education">
          <!-- <div class="item-title">
            升学择业
          </div> -->
          <!-- <div
            id="echartsWordcloud"
            class="item-container"
            style="width:400px;height:200px"
          /> -->
        </div>
      </div>
    </div>
    <div
      class="back"
      @click="goBack"
    />
  </div>
</template>
<script>
import {
  // cakeEcharts,
  // barEcharts,
  // warnPieEcharts,
  // relationPieEcharts,
  radarEcharts,
  echartsLiquidfill,
  // echartsWordcloud,
  moodBarEcharts
} from "./studentPicEacharts.js";
import { studentPicPreData } from '@/assets/data.js';

import ModelSide from '@/components/modelSide.vue'
export default {
  components: {
    ModelSide,
  },
  data () {
    return {
      studentPicPreData,
      echartsLiquidfillList: [{
        id: 'echartsLiquidfillStressPre',
        data: [0.9],
        color: '#FF8C78'
      }, {
        id: 'echartsLiquidfillSuitPre',
        data: [0.7],
        color: '#3C97EB'
      }, {
        id: 'echartsLiquidfillMethodPre',
        data: [0.45],
        color: '#3C98EB'
      }],
      moodBardata: {
        dataX: ['5月5日', '5月6日', '5月7日', '5月8日', '5月9日', '5月10日', '5月11日', '5月12日', '5月13日', '5月14日', '5月15日'],
        dataY: [80, 86, 87, 85, 82, 85, 84, 83, 88, 86, 83],
        dataf: [70, 70, 70, 70, 70, 70, 70, 70, 70, 70, 70]
      }
    }
  },
  mounted () {
    // let color = ['#ccc']
    // relationPieEcharts(color, this.$echarts)
    radarEcharts(this.$echarts)
    this.echartsLiquidfillList.forEach(item => {
      console.log(item);
      echartsLiquidfill(this.$echarts, item)
    })
    this.$nextTick(() => {
      moodBarEcharts(this.$echarts, this.moodBardata, 'warnBarMainPre');
    })

  },
  methods: {
    // 跳转到干预后页面
    goStdtentAfter () {
      this.$router.push('/studentAfter')
    },
    // 跳回知识结构页面
    goBack () {
      this.$router.push('/knowledge')
    },

  }
}
</script>
<style lang="scss" scoped>
.student-pre {
  width: 1920px;
  height: 1080px;
  padding: 0 24px;
  background: url("../assets/studentImages/student-bg.png") no-repeat 0 0/100%;
}
.student-header {
  background: url("../assets/studentImages/student-header.png") no-repeat 0 0/100%;
  width: 100%;
  height: 159px;
  .after-btn {
    position: fixed;
    background-color: #409eff;
    opacity: 0;
    right: 0;
    top: 0;
    width: 100px;
    height: 100px;
  }
}
.student-main {
  display: flex;
  margin-top: -61px;
  .student-main-con {
    width: 600px;
    .content-item-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 10px;
      &.barside {
        width: 47% !important;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        &:nth-child(1) {
          .circle {
            background: #ff8a58;
          }
        }
        &:nth-child(2) {
          .circle {
            background: #45d797;
          }
        }
        &:nth-child(3) {
          .circle {
            background: #faff89;
          }
        }
        &:nth-child(4) {
          .circle {
            background: #faff89;
          }
        }
      }
      .content-item-info-img {
        width: 100px;
        height: 100px;
        // background: #ccc;
      }
    }
    .student-main-con-item {
      display: flex;
      justify-content: space-between;
      width: 480px;
      height: 300px;
      margin-bottom: 27px;
      padding: 78px 20px 0;
      .content-item {
        display: flex;
      }
    }
    .know-yourself {
      background: url("../assets/studentImages/know-yourself-bg.png") no-repeat
        0 0/100%;
      padding-top: 103px;
    }
    .interpersonal-relation {
      display: flex;
      flex-wrap: wrap;
      background: url("../assets/studentImages/interpersonal-relation-bg.png")
        no-repeat 0 0/100%;
      .content-item-info {
        display: flex;
        width: 40%;
        height: 100px;
      }

      .content-item-info-title {
        display: flex;
        align-items: center;
        color: #fff;
        margin-bottom: 30px;
        .title-block {
          width: 8px;
          height: 8px;
          background: #ff8a58;
          margin-right: 6px;
        }
      }
      .bar-big {
        position: relative;
        width: 84px;
        height: 4px;
        background: rgba(153, 153, 153, 0.2);
        border-radius: 2px;
        // opacity: 0.2;
        .bar-small {
          position: absolute;
          left: 0;
          top: 0;
          width: 48px;
          height: 4px;

          border-radius: 2px;
        }
      }
    }
    .emotional-development {
      // display: flex;
      // justify-content: space-between;
      background: url("../assets/studentImages/emotional-development-bg.png")
        no-repeat 0 0/100%;
      // padding: 78px 20px 0;
      .content-item-info {
        box-sizing: border-box;
        height: 200px;
        background: linear-gradient(
          180deg,
          rgba(7, 82, 249, 0.15) 0%,
          rgba(7, 71, 249, 0.05) 99%
        );
        padding: 10px 11px 27px;
        margin-right: 0;
        // opacity: 0.4;

        .content-item-info-chart {
          width: 72px;
          height: 72px;
          margin-left: 30px;
        }
      }
      .content-item-info-count {
        margin: 20px 0 -20px 0;
      }
      .content-item-info-img {
        width: 111px;
        height: 94px;
      }
    }
    .learn-study {
      height: 313px;
      background: url("../assets/studentImages/learn-study-bg.png") no-repeat 0
        0/100%;
      padding-top: 75px;
    }
    .social-adaptability {
      width: 100%;
      height: 260px;
      background: url("../assets/studentImages/social-adaptability-bg.png")
        no-repeat 0 0/100%;
      padding-top: 85px;
    }
    .careers-education {
      height: 320px;
      background: url("../assets/studentImages/careers-education-bg2.png")
        no-repeat 0 0/100%;
      padding-top: 60px;
    }
    .student-main-con-social {
      display: flex;
      width: 100%;
      .item-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 150px;
        .item-echarts {
          width: 100%;
          height: 150px;
        }
      }
      img {
        width: 103px;
        height: 103px;
      }
    }
  }
  .student-main-center {
    width: 100%;
    margin: 0 24px;
    .audio-status {
      position: relative;
      top: 0;
      width: 120px;
      height: 655px;
      .animation2,
      .animation3 {
        width: 120px;
        height: 120px;
        border: 1px solid #333;
        border-radius: 55%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        background-color: red;
        .music-time {
          font-size: 30px;
          font-family: DINAlternate-Bold, DINAlternate;
          // font-weight: bold;
          color: #ffffff;
        }
      }
      .big-animation {
        animation: spread 3s infinite;
        animation-play-state: running;
      }
    }
  }
}
.student-foot {
  width: 864px;
  height: 294px;
  background: url("../assets/studentImages/footer-bg.png");
  .student-foot-title {
    display: flex;
    align-items: center;
    padding: 14px 0 0 64px;
    .student-foot-title-big {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
      margin-right: 18px;
    }
  }
  .status-list {
    display: flex;
    color: #dcedff;
    font-size: 14px;
    .status-list-item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #ff7575;
        border-radius: 50%;
        margin-right: 8px;
      }
    }
  }
  .student-foot-con {
    display: flex;
    .line-echarts {
      width: 507px;
      height: 160px;
      margin-top: 60px;
      #warnBarMain {
        width: 100%;
        height: 100%;
      }
    }
    .student-foot-con-vedio {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      align-items: center;
      width: 276px;
      height: 179px;
      background: #11277e;
      // background: rgba(40, 66, 186, 0.8);
      // opacity: 0.4;
      border-radius: 6px;
      border: 1px solid #316ff9;
      padding: 15px 18px 3px;
      margin: 70px 0 0 55px;
      font-size: 12px;
      color: #cde6ff;
      video {
        width: 240px;
        height: 136px;
        margin-bottom: 3px;
      }
    }
  }
}
.orange {
  color: #ffae00;
}
.blue {
  color: #8bbce7;
}
.text {
  margin-top: 32px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #e2efff;
}
.back {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 100px;
  height: 100px;
  background-color: #409eff;
  opacity: 0;
}
.slef-red {
  color: #ff5454;
}
.slef-orange {
  font-size: 14px;
  color: #ffdc18;
}
.slef-green {
  color: #00cb65;
}
// 圆圈扩散动画
@keyframes spread {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  // 50% {width: 300px;height:300px;opacity: 0.5;}
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}
// 人际关系

.div3 {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 80px;
  justify-content: flex-start;
  height: 72px;
  width: 22.5%;
}
.circle {
  width: 72px;
  height: 72px;
  position: absolute;
  border-radius: 50%;
  background: #3f66ff;
  top: 0;
  position: relative;
  .num {
    width: 72px;
    height: 72px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #e2efff;
  }
}

.pie-left,
.pie-right {
  width: 72px;
  height: 72px;
  position: absolute;
  left: 0px;
  right: 0px;
}
.left,
.right {
  display: block;
  width: 72px;
  height: 72px;
  background: #14378d;
  border-radius: 50%;
  position: absolute;
  left: 0px;
  top: 0px;
  /*旋转30度*/
  /*transform: rotate(30deg);*/
}
.pie-right,
.right {
  clip: rect(0, auto, auto, 36px);
}
.pie-left,
.left {
  /*截图工具 top rigt,bottom, left*/
  clip: rect(0, 36px, auto, 0);
}

.mask {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  position: absolute;
  left: 10px;
  top: 10px;
  background: #0a207a;
}
</style>